export const TIME_FORMAT = "HH:mm:ss"
export const DATE_FORMAT_STRAPI = "YYYY-MM-DD"
export const MINUTI_IN_UN_GIORNO: number = 60 * 24
export const ALTEZZA_CALENDAR = 1100
export const ALTEZZA_CALENDAR_CONTENT = ALTEZZA_CALENDAR-35
export const CMS_SINGLE_PALINSTESTO_CONTENUTI_ROUTE = "admin/content-manager/collection-types/api::scheduled-content.scheduled-content"